export const WEMBII_SUPPORT_SESSION_STORAGE_KEY = "wembiiSupportActiveConversationId";

export function persistSupportConversationId(conversationId: string) {
  sessionStorage.setItem(WEMBII_SUPPORT_SESSION_STORAGE_KEY, conversationId);
}

export function readSupportConversationId() {
  return sessionStorage.getItem(WEMBII_SUPPORT_SESSION_STORAGE_KEY);
}

export function clearSupportConversationId() {
  sessionStorage.removeItem(WEMBII_SUPPORT_SESSION_STORAGE_KEY);
}
